export const millisecondsIn60Hz = 16;

export default class DebouncedToggle {
	constructor($timeout) {
		'ngInject';

		this._toggleInProgress = false;
		this.$timeout = $timeout;
	}

	_debounceToggle() {
		if (this._toggleInProgress) {
			return Promise.reject('Toggle already in progress!');
		}

		this._toggleInProgress = true;
		return this.$timeout(
			() => (this._toggleInProgress = false),
			millisecondsIn60Hz
		);
	}

	_ignore() {
		// ignore promise rejection
	}
}